var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "company",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1030",
    "data-name": "Rectangle 1030",
    width: 96,
    height: 96,
    rx: 12,
    fill: "#b2d6f3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "corporate_fare_black_24dp",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1135",
    "data-name": "Rectangle 1135",
    width: 48,
    height: 48,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693",
    "data-name": "Path 3693",
    d: "M22,11V7a4.012,4.012,0,0,0-4-4H6A4.012,4.012,0,0,0,2,7V35a4.012,4.012,0,0,0,4,4H38a4.012,4.012,0,0,0,4-4V15a4.012,4.012,0,0,0-4-4ZM18,35H6V31H18Zm0-8H6V23H18Zm0-8H6V15H18Zm0-8H6V7H18ZM38,35H22V15H38ZM34,19H26v4h8Zm0,8H26v4h8Z",
    transform: "translate(2 3)",
    fill: "#0078d7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.59e4c3231ed01f7ce80a20274ef4b5bc.svg";
export { ForwardRef as ReactComponent };